exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3w-XguhjTU4mm0IPOZOD7A {\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n._1hTHUc6NgmSvfW_w_U5_2B {\n    margin-right: 15px;\n    margin: 3px 15px 0 0;\n}\n", ""]);

// exports
exports.locals = {
	"spinnerContainer": "_3w-XguhjTU4mm0IPOZOD7A",
	"iconMargin": "_1hTHUc6NgmSvfW_w_U5_2B"
};